import Vue from 'vue'
import Navigation from './components/navigation-component'
import Footer from './components/footer-component'
import CMSBar from './components/cms-bar-component'
import router from './routes'
import store from './store'
import VueRouter from 'vue-router'
import Plugins from './plugins'
import VueAnalytics from 'vue-analytics'
import VueLazyload from 'vue-lazyload'
import VueHead from 'vue-head'
import VueMasonry from 'vue-masonry-css'
import Constants from './constants'
import * as VueGoogleMaps from 'vue2-google-maps'; 
import _ from 'lodash'
import de from 'vee-validate/dist/locale/de';
import VeeValidate, { Validator } from 'vee-validate'
import AOS from 'aos';

import {TweenMax, Power2, TimelineLite, TimelineMax} from "gsap/TweenMax";

Vue.use(VeeValidate);
Vue.use(VueMasonry);
Vue.use(Constants);
Vue.use(VueHead)
Vue.use(VueRouter)
Vue.use(Plugins)
Vue.use(VueLazyload)
Vue.use(VueAnalytics, {
    id: 'UA-XXXXXXX-XX',
    router
})
Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyCweOScIHMSLyhuk1bUkomjeSygyHI7dZ0',
    }
});  
window.axios = require('axios')

new Vue({
    el: '#app',
    router,
    store,
    data () {
    	return {
            sections: [],
            locale: this.$route.params.locale
    	}
    },
    template: `
    <div id="app" v-if="sections.length">
        <cms-bar></cms-bar>
        <navigation :sections="sections"></navigation>     
		<transition v-on:enter="enter" v-on:afterEnter="afterEnter" v-on:before-leave="beforeLeave" v-on:leave="leave" v-on:before-enter="beforeEnter" appear mode="out-in">
			<router-view :key="$route.fullPath"></router-view>
		</transition>
		<footer-component></footer-component>
    </div>`,
    components: {
    	cmsBar: CMSBar,
        navigation: Navigation,
        footerComponent: Footer
    },
    created: function () {
        document.title = 'Ekoarchitectur'
        this.getData()
        this.errorsLanguage()
        AOS.init({
            // duration: 800,
            once: true,
            throttleDelay: 100,
            offset: 120
        })        
    },
    methods: {
        errorsLanguage() {
            if (this.locale == 'de') {
                this.$validator.localize(`${this.locale}`, de)
            }
        },         
    	getData () {
    		var self = this

            axios.all([this.getSections(), this.getPages()])
                .then(axios.spread(function (sections, pages) {
                    self.sections = sections.data

                    self.projects = _.chain(self.sections)
                    .find({ 'type': 'projects' })
                    .get('collections')
                    .find({ name: 'Projekte' })
                    .value()

                    self.$store.commit('sections', sections.data)
                    self.$store.commit('pages', pages.data)
                    self.$store.commit('projects', self.projects.pages) 
                }));
    	},
    	getSections () {
    		return axios.get(`/${this.$route.params.locale}/api/v2/sections`)
    	},
    	getPages() {
    		return axios.get(`/${this.$route.params.locale}/api/v2/pages`)
    	},
        beforeEnter: function (el) {
            window.scrollTo(0, 0)
        },
        enter: function (el, done) {
            var tl = new TimelineMax({onComplete: done})
            this.$nextTick(function(){
                let all = document.querySelector('body')
                tl
                .set(all,{opacity: 0})
                .to(all, 0.3, {opacity: 1}, 0.3);
                AOS.refreshHard();
                done()
            })          
        },
        afterEnter: function (el) {
            
        },
        beforeLeave: function(el) {
            
        },
        leave: function (el, done) {
            let all = document.querySelector('body')
            var tl = new TimelineMax({onComplete: done})
                tl
                .to(all, 0.3, {opacity: 0}, 0.1)
        }
    }
})
